import { render, staticRenderFns } from "./protocolAdd.vue?vue&type=template&id=59e9e7db&scoped=true&"
import script from "./protocolAdd.vue?vue&type=script&lang=js&"
export * from "./protocolAdd.vue?vue&type=script&lang=js&"
import style0 from "./protocolAdd.vue?vue&type=style&index=0&id=59e9e7db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e9e7db",
  null
  
)

export default component.exports